import React from 'react'
import MainHeadToAppend from './MainHeadToAppend'

function HeaderExtra(props) {
  return (
    <div className="MainTopButtonWrapper TopCornerButtonContainerScrolled">
        <MainHeadToAppend/>
        {/* <div className="TopMenuPanel" id="TopCornerButtonContainer">
            <div className="TopBackgroundThatWillChange"></div>
            <div className="TopMenuSectionWrapper" style={{display: "flex"}} id="TopMenuMainWrapper">
                <a href="/">
                    <img src="/Assets/images/Icon/pingingo-icon.svg" className="PinginGoLogo"/>
                </a>
                <div className="MainTopSectionButtonWrapper BasicChildMargin" id="UserTopInfoWrapper">
                    <div className="UserTopInfoWrapper" id="LanguageChangeTopMenu">
                        <div className="UserTopProfileIcon BasicThinGreyBorder Selectable2">
                            <img src="/Assets/images/CountryCode/Indonesia.svg" className="ImageFullCover"/>
                        </div>
                    </div>
                    <a className="BasicTextButton BasicBoxShadow ListinYourAccButton SignInButtonTop Selectable ListingMitraButtons">
                        <div style={{width: "fit-content", height: "fit-content", display: "flex", margin: "auto"}}>
                            <img className="BasicIconInsideButton" style={{marginLeft: 0}}/>
                            <p id="ListYourAccBtnTxt" className="HideOnMobile" style={{marginTop: "auto", marginBottom: "auto"}}>Listing your Accommodation</p>
                            <p id="ListYourAccBtnTxtShort" className="ShowOnMobile" style={{marginTop: "auto", marginBottom: "auto"}}>Join Now</p>
                        </div>
                    </a>
                <button className="BasicTextButton BasicBoxShadow OrangeButton2 SignInButtonTop Selectable" id="LoginInButtonTop" onClick={()=> window.InstantiateLoginPanel('')}>Masuk</button>
                <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable" id="SignInButtonTop" onClick={()=> window.InstantiateLoginPanel('')}>Register</button>
                </div>
            </div>
        </div> */}
        <div className="TopMenuPanel TopMenuPanelBlueGrad PaddingLeftRightForSafari">
            <div className="TopMenuSectionWrapper TopNonIndexSearchSection">
                <div className="TopArrowAndHeaderWrapper">
                    <a id="BackArrowNonPaymentA" className="BackArrowBigHeader">
                        <img src="/Assets/images/ButtonIcon/back-arrow-white.svg" className="BackArrowBigHeader Selectable2" id="BackArrowNonPayment"/>
                    </a>
                    <p className="RoomUnavailableHeaderText InterRegularTextFont" style={{color: "white", margin: "auto 0"}} id="WhichPageSectionIsText">{props.page}</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default HeaderExtra